import type { AuthError } from "@supabase/supabase-js";
import { COMPANY } from "./company";

/**
 * What to show for a failed sign-in.
 *
 * A deletion request bans the account (migration 20260912000400), and GoTrue
 * words that as "User is banned" — which reads as a punishment to someone who
 * asked for it. Everything else is GoTrue's own message.
 */
export function authErrorMessage(error: AuthError): string {
  if (error.code === "user_banned") {
    return `This account is scheduled for deletion, so it can no longer sign in. ` +
      `To cancel, email ${COMPANY.privacyEmail}.`;
  }
  return error.message;
}
